import { render } from "./WeeklyReport.vue?vue&type=template&id=c7d5409e&scoped=true"
import script from "./WeeklyReport.vue?vue&type=script&lang=js"
export * from "./WeeklyReport.vue?vue&type=script&lang=js"

import "./WeeklyReport.vue?vue&type=style&index=0&id=c7d5409e&scoped=true&lang=css"
import "./WeeklyReport.vue?vue&type=style&index=1&id=c7d5409e&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7d5409e"]])

export default __exports__